import React, { Component } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { FormInput, TextAreaField, DropDownList } from "../../common";
import { Button, Form, Grid, Header, Segment, Label } from "semantic-ui-react";
import { messages } from "../../../utils";
import LazyLoad from "react-lazyload";

const { validation } = messages;

export default class SubmitURL extends Component {
  onSubmitBtnClick(values) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values);
  }
  render() {
    const { isLoading, categoryLists } = this.props;
    return (
      <div style={{ marginTop: "10px" }}>
        <Grid columns={2} style={{marginLeft: '19%'}}>
          <Grid.Column>
            <Header as="h3" textAlign="center" style={{width: '205%'}}>
              Submit URL
            </Header>
            <Segment style={{width: '205%', textAlign:'center'}}>
              <Form size="large">
                <Formik
                  initialValues={{
                    storyTitle: "",
                    url: "",
                    categoryId: "",
                    description: ""
                  }}
                  onSubmit={values => this.onSubmitBtnClick(values)}
                  validationSchema={Yup.object().shape({
                    storyTitle: Yup.string()
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField),
                    url: Yup.string()
                      .url("Should contain http or https")
                      .min(6, "Minimum six")
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField),
                    categoryId: Yup.string().required(validation.requiredField),
                    description: Yup.string()
                      .min(10, "Minimum ten")
                      .max(300, "Maximum characters exceed 300")
                      .required(validation.requiredField)
                  })}
                  render={({
                    values,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    errors,
                    touched
                  }) => (
                    <div>
                      {/* <strong style={{ paddingBottom: "5px" }}>
                        You can post this URL from{" "}
                        <a href="https://play.google.com/store/apps/details?id=com.socialbookmarker">
                          android 
                        </a>{" "} or {" "} 
                        <a href="https://apps.apple.com/app/social-bookmarker/id1514832913">
                          ios 
                        </a>{" "}
                        and on single click you can build 32+ back-links.
                        After that you can send back-links report at your email
                        address. Our link building tool is free. Download now
                      </strong> */}
                      {/* <div style={{ textAlign: "center" }}>
                        <LazyLoad resize>
                          <a href="https://play.google.com/store/apps/details?id=com.socialbookmarker">
                            <img
                              src={process.env.PUBLIC_URL + '/playstore.png'}
                              style={{
                                width: "20%",
                                height: "20%",
                                paddingTop: "2%"
                              }}
                            />
                          </a>
                          <a href="https://apps.apple.com/app/social-bookmarker/id1514832913">
                          <img
                            src={process.env.PUBLIC_URL + '/appstore.png'}
                            style={{
                              width: "17%",
                              height: "20%",
                              paddingTop: "2%"
                            }}
                          />
                        </a>
                    
                        </LazyLoad>
                      </div> */}
                      <div className="row">
                        <div className="col-sm">
                          {errors.storyTitle && touched.storyTitle && (
                            <Label>{errors.storyTitle}</Label>
                          )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            value={values.storyTitle}
                            fluid
                            placeholder="Story Title"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="storyTitle"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm mt-4">
                          {errors.url && touched.url && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.url}
                            </Label>
                          )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            value={values.url}
                            fluid
                            placeholder="URL"
                            type="text"
                            name="url"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm mt-4">
                          {errors.description && touched.description && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.description}
                            </Label>
                          )}
                          <TextAreaField
                            style={{ marginBottom: "10px", minHeight: 100 }}
                            value={values.description}
                            placeholder="Description"
                            name="description"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm mt-4">
                          {errors.categoryId && touched.categoryId && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.categoryId}
                            </Label>
                          )}
                          <DropDownList
                            selection
                            value={values.categoryId}
                            options={categoryLists[0]}
                            fluid
                            placeholder="Category"
                            name="categoryId"
                            onBlur={() => setFieldTouched("categoryId", true)}
                            onChange={(e, { value }) =>
                              setFieldValue("categoryId", value)
                            }
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-sm text-right"
                          style={{ paddingTop: "10px" }}
                        >
                          <Button
                            loading={isLoading}
                            color="blue"
                            type="submit"
                            fluid
                            size="large"
                            onClick={() => handleSubmit(values)}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                />
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}
